import amplitude from 'src/_shared/amplitude';
import { FeatureFlagAmplitude } from 'src/_shared/featureFlag';
import { GROUP_CODES } from 'src/constants/code.constants';

export enum ConfigurationStepId {
  BAND = 'band',
  FORMAT = 'format',
  BOX_STYLE = 'box-style',
}
export enum ConfigurationStepFlavor {
  BAND = 'band',
  ALL_FORMAT = 'all_format',
  FORMAT_BY_BAND = 'format_by_band',
  BOX_STYLE = 'box_style',
}

export interface IConfigurationStep {
  id: ConfigurationStepId;
  flavor: ConfigurationStepFlavor;
}

const ProductConfigurationStep = {
  [GROUP_CODES.PRINT_CLASSIC]: [
    {
      id: ConfigurationStepId.FORMAT,
      flavor: ConfigurationStepFlavor.ALL_FORMAT,
    },
  ],
  [GROUP_CODES.POSTER]: [
    {
      id: ConfigurationStepId.FORMAT,
      flavor: ConfigurationStepFlavor.ALL_FORMAT,
    },
  ],
  [GROUP_CODES.PRINT_VINTAGE]: [
    {
      id: ConfigurationStepId.FORMAT,
      flavor: ConfigurationStepFlavor.ALL_FORMAT,
    },
  ],
  [GROUP_CODES.PRINT_PRO]: [
    {
      id: ConfigurationStepId.FORMAT,
      flavor: ConfigurationStepFlavor.ALL_FORMAT,
    },
  ],
  [GROUP_CODES.POSTER_PRO]: [
    {
      id: ConfigurationStepId.FORMAT,
      flavor: ConfigurationStepFlavor.ALL_FORMAT,
    },
  ],
  [GROUP_CODES.HAPPY_CASE_CLASSIC]: [
    {
      id: ConfigurationStepId.BOX_STYLE,
      flavor: ConfigurationStepFlavor.BOX_STYLE,
    },
  ],
  [GROUP_CODES.HAPPY_CASE_VINTAGE]: [
    {
      id: ConfigurationStepId.BOX_STYLE,
      flavor: ConfigurationStepFlavor.BOX_STYLE,
    },
  ],
  [GROUP_CODES.FOTOKIT_HOMEDECOR]: [],
  [GROUP_CODES.FOTOKIT_MINISCRAP]: [],
};
export const getNextStep = (
  productGroup: GROUP_CODES,
  stepsDone: ConfigurationStepId[],
  stepsToSkip: ConfigurationStepId[],
): IConfigurationStep | undefined => {
  let nextStep: IConfigurationStep | undefined = undefined;

  const allProductSteps = ProductConfigurationStep[productGroup];
  if (!!allProductSteps) {
    allProductSteps.forEach(step => {
      if (nextStep) return;
      if (stepsDone.includes(step.id)) return;
      if (stepsToSkip.includes(step.id)) return;
      nextStep = step;
    });
  }

  return nextStep;
};
